import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { Fab } from "@mui/material";

function ScrollToTopButton(): JSX.Element {
  const scrollToTop = (): void => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Fab
      color="default"
      onClick={scrollToTop}
      size="small"
      sx={{
        position: "fixed",
        bottom: 22,
        right: 70,
        zIndex: 1000,
      }}
      variant="extended"
    >
      Topo <ExpandLessIcon />
    </Fab>
  );
}

export default ScrollToTopButton;
